import React, { useContext } from "react";
import { Button } from "ratel-ui";

import Icon from "../../../components/icon";
import { SimuladaoContext } from "../../../core/context";
import Tabbable from "../../../components/tabbable";
import * as S from "./styles";
import "./ModalRules.scss";

const ModalRules = ({ toggleModal }) => {
  const { simuladaoFromJSON } = useContext(SimuladaoContext);

  return (
    <S.Container>
      <div className="modal modal-rules is-active">
        <div className="modal-background" onClick={() => toggleModal()} />
        <div className="modal-card modal-rules-card">
          <header className="modal-card-head modal-rules-header">
            <span className="modal-rules-header-title">INSTRUÇÕES PARA O SIMULADO</span>
          </header>

          <div className="modal-rules-body">
            <div className="modal-rules-item">
              <div>
                <div className="modal-rules-item-title">Simulado</div>
                <div className="modal-rules-item-text">
                  Este é o simuladão do {simuladaoFromJSON.periodString}! Neste Desafio,{" "}
                  <strong>são {simuladaoFromJSON.questions} questões estilo ENEM totalmente inéditas.</strong>
                  <ul className="modal-rules-item-list">
                    <li>{simuladaoFromJSON.questionsLanguage} questões de Linguagens</li>
                    <li>{simuladaoFromJSON.questionsHuman} questões de Ciências Humanas</li>
                    <li>{simuladaoFromJSON.questionsNatural} questões de Ciências da Natureza</li>
                    <li>{simuladaoFromJSON.questionsMath} questões de Matemática</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="modal-rules-item">
              <div>
                <div className="modal-rules-item-title">Respostas</div>
                <div className="modal-rules-item-text">
                  As respostas são <strong>objetivas.</strong> <br />
                  Você pontuará apenas se marcar a resposta correta. Existe apenas <strong>UMA</strong> resposta correta
                  por questão. Respostas em branco serão consideradas como <strong>ERRADAS</strong>. <br />
                  Se você encontrar alguma incoerência nas questões, você terá a opção de reportar para a nossa equipe
                  durante o andamento da prova.
                </div>
              </div>
            </div>

            <div className="modal-rules-item">
              <div>
                <div className="modal-rules-item-title">Duração</div>
                <div className="modal-rules-item-text">
                  O Simuladão <strong>começa às {simuladaoFromJSON.startHour}</strong>, e se{" "}
                  <strong>encerra às {simuladaoFromJSON.endHour}</strong> do horário de Brasília. <br />O Simuladão será
                  fechado para participação entre {simuladaoFromJSON.closingHour} e {simuladaoFromJSON.feedbackHour}.
                  Você terá <strong>até 5 horas</strong> para resolver 90 questões. <br />
                  Não é possível parar o Simuladão! O tempo continuará correndo até que você encerre o Simuladão ou o
                  tempo se esgote. Caso o tempo se encerre, serão enviadas apenas as respostas que você marcou.
                </div>
              </div>
            </div>

            <div className="modal-rules-item">
              <div>
                <div className="modal-rules-item-title">Gabarito</div>
                <div className="modal-rules-item-text">
                  O gabarito das respostas, resolução em vídeo, a sua pontuação individual e o ranking geral dos alunos
                  serão disponibilizados apenas <strong>às {simuladaoFromJSON.feedbackHour} (Brasília).</strong>
                </div>
              </div>
            </div>

            <div className="modal-rules-item">
              <div>
                <div className="modal-rules-item-title">Pontuação</div>
                <div className="modal-rules-item-text">
                  As pontuações são calculadas de acordo com a média de pontos feita por todos os participantes do
                  Simuladão. Ou seja, <strong>sua pontuação está relacionada com a média dos outros alunos</strong> e,
                  por isso, quanto melhor você for em relação à média de pontos deles, maior a sua nota.
                </div>
              </div>
            </div>

            <div className="modal-rules-item">
              <div>
                <div className="modal-rules-item-title">Ranking</div>
                <div className="modal-rules-item-text">
                  Suas respostas contarão para o Ranking se, e somente se, você iniciar o simulado até{" "}
                  {simuladaoFromJSON.startLimitHour} (horário de Brasília) e finalizar o mesmo até o horário limite (
                  {simuladaoFromJSON.endHour} horas). <br />
                  Simulados iniciados após as {simuladaoFromJSON.feedbackHour} do dia {simuladaoFromJSON.date} não
                  entram para o ranking.
                  <br />
                  <strong>Somente as 100 primeiras colocações participarão do Ranking. </strong>O Ranking ficará
                  disponível na “Minha Área” (página inicial da plataforma).
                </div>
              </div>
            </div>

            <div className="modal-rules-item">
              <div>
                <div className="modal-rules-item-title">Funcionalidade dos botões</div>
                <div className="modal-rules-item-text">
                  Os ícones listados aqui aparecerão durante o simulado do BT, saiba qual a funcionalidade de cada um
                  deles:
                  <ul>
                    <li className="modal-rules-icons">
                      <div className="modal-rules-icons-wrapper">
                        <div className="modal-rules-icons-circle">
                          <Icon icon="toggleArea" width={16} height={16} />
                        </div>
                      </div>
                      <span>
                        Neste botão você poderá navegar pelas áreas de conhecimento a qualquer momento do simulado. Ao
                        trocar de área, você será levado para a primeira questão da área escolhida.
                      </span>
                    </li>
                    <li className="modal-rules-icons">
                      <div className="modal-rules-icons-wrapper">
                        <div className="modal-rules-icons-circle">
                          <Icon icon="max" width={16} height={16} />
                        </div>
                        <div className="modal-rules-icons-circle">
                          <Icon icon="min" width={16} height={16} />
                        </div>
                      </div>
                      <span>
                        Este botão permite que você expanda o simulado para o modo tela cheia ou contraia para mostrar
                        os menus de navegação da plataforma
                      </span>
                    </li>
                    <li className="modal-rules-icons">
                      <div className="modal-rules-icons-wrapper">
                        <Icon icon="report" width={16} height={16} />
                      </div>
                      <span>
                        Você pode reportar um erro que encontrou em uma questão ou no próprio sistema através desse
                        ícone
                      </span>
                    </li>
                    <li className="modal-rules-icons">
                      <div className="modal-rules-icons-wrapper">
                        <div className="modal-rules-icons-question fill" />
                        <div className="modal-rules-icons-question fill" />
                        <div className="modal-rules-icons-question" />
                        <div className="modal-rules-icons-question" />
                        <div className="modal-rules-icons-question" />
                      </div>
                      <span>
                        Contagem das questões já respondidas, dentro da área de conhecimento específica. Clique para
                        navegar diretamente para a questão.
                      </span>
                    </li>
                    <li className="modal-rules-icons">
                      <div className="modal-rules-icons-wrapper">21 de 90</div>
                      <span>Contagem de questões já respondidas do total</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="modal-rules-item">
              <div>
                <div className="modal-rules-item-title"> Celular</div>
                <div className="modal-rules-item-text">
                  Embora você possa responder o Simuladão no celular,{" "}
                  <strong>recomendamos fortemente que você use uma tela maior para ler melhor as questões.</strong>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-rules-footer">
            <Tabbable onClick={() => toggleModal()}>
              <Button link className="modal-rules-footer-button">
                FECHAR
              </Button>
            </Tabbable>
          </div>
        </div>
      </div>
    </S.Container>
  );
};

export default ModalRules;
